import { checkLanguageTestLevelInUseApi } from "@/api/services/global/master";
import { FormField } from "@/components/elements/FormField";
import { Input } from "@/components/elements/Input";
import { Select } from "@/components/elements/Select";
import { Table } from "@/components/elements/Table";
import { TMasterLanguageTestForm, TMasterLanguageTestLevelForm } from "@/features/master-data/types/masterDataLanguageTestForm";
import { useFormTable } from "@/hooks/useFormTable";
import { Box, styled } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { FC } from "react";
import { useFormContext } from "react-hook-form";

type TLanguageTestLevelFormTableProps = {
  languageTestId?: number;
};

export const LanguageTestLevelFormTable: FC<TLanguageTestLevelFormTableProps> = ({ languageTestId }) => {
  const { control, getValues } = useFormContext<TMasterLanguageTestForm>();

  // Saved levels selected in 外国人DB cannot be deleted: check right away instead of waiting for 保存
  const checkLevelDeletable = async (index: number) => {
    const levelId = getValues(`languageTestLevels.${index}.id`);
    if (!languageTestId || !levelId) {
      return true;
    }
    // Error toast is shown by the globalApi interceptor (GET errors)
    return checkLanguageTestLevelInUseApi(languageTestId, levelId)
      .then(() => true)
      .catch(() => false);
  };

  const formColumns: MRT_ColumnDef<TMasterLanguageTestLevelForm>[] = [
    {
      header: "レベル",
      Cell: ({ row }) => (
        <FormField control={control} name={`languageTestLevels.${row.index}.level`}>
          <Input />
        </FormField>
      ),
    },
    {
      header: "育成就労日本語要件判断指標",
      Cell: ({ row }) => (
        <FormField control={control} name={`languageTestLevels.${row.index}.ikuseiJapaneseRequirementIndicator`}>
          <Select enumName="EIkuseiJapaneseRequirementIndicator" />
        </FormField>
      ),
    },
  ];

  const { table } = useFormTable({
    columns: formColumns,
    control,
    name: "languageTestLevels",
    initFieldData: { level: "", ikuseiJapaneseRequirementIndicator: null },
    primaryKey: "id",
    beforeDeleteRow: checkLevelDeletable,
  });

  return (
    <TableWrapper>
      <Table table={table} maxHeight={400} />
    </TableWrapper>
  );
};

const TableWrapper = styled(Box)`
  .MuiTableHead-root {
    th {
      font-size: 14px;
    }
  }
`;
